export const ThemeType = {
  light: 'FPlusLight',
  dark: 'FPlusDark',
} as const
export type ThemeType = (typeof ThemeType)[keyof typeof ThemeType]
